import React, { useCallback, useState } from 'react'
import { WordReadabilityStyles } from './Style'
import { Tabs } from 'components'
import { wordReadabilityHooks } from '.'

const WordReadability = () => {
    const [currentTab, setCurrentTab] = useState(0)
    const tabs = wordReadabilityHooks.useTabs()

    const handleTab = useCallback((index) => {
        setCurrentTab(index)
    }, [])

    const Component = tabs[currentTab].component

    return (
        <WordReadabilityStyles>
            <div className='wrap-tabs'>
                <Tabs tabs={tabs} handleTab={handleTab} />
            </div>
            <Component />
        </WordReadabilityStyles>
    )
}

export default WordReadability